import React, { useEffect, useState } from "react";
import { Services } from "../../api/Services";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import appleimg from "../../images/apple.png";
import google_fit from "../../images/gfit.png";
import watchimg from "../../images/colmi.png";
import fitbitimg from "../../images/fitbit.png";
import garminimg from "../../images/garmin.png";
import samsungimg from "../../images/samsung.png";
import { Bar } from "react-chartjs-2";
import Chart from "chart.js/auto";
import ProgressModel from "./modals/ProgressModals/ProgressModel";
import EditBio from "./modals/BioModals/EditBio";
import { BASE_URL_MEDIA } from "../../api/Constants";

const UserStats = ({ userId }) => {
  const currentDate = new Date();
  const enddDatee = currentDate.toISOString().split("T")[0];
  //start month date
  const thirtyDaysBeforeDate = new Date();
  thirtyDaysBeforeDate.setDate(thirtyDaysBeforeDate.getDate() - 29);

  const monthstartDate = thirtyDaysBeforeDate.toISOString().split("T")[0]; // Format: YYYY-MM-DD

  //week month date
  const sevenDaysBeforeDate = new Date();
  sevenDaysBeforeDate.setDate(sevenDaysBeforeDate.getDate() - 6);

  const weekStartDate = sevenDaysBeforeDate.toISOString().split("T")[0]; // Format: YYYY-MM-DD

  const [isLoading, setIsLoading] = useState(false);
  const [graphData, setGraphData] = useState([]);
  const [graphValues, setGraphValues] = useState([]);
  const [userObject, setUserObject] = useState({});
  const [activeTab, setActiveTab] = useState("stats");
  const [platform, setPlatform] = useState("apple");
  const [startDate, setStartDate] = useState(weekStartDate);
  const [endDate, setEndDate] = useState(enddDatee);
  const [totalSteps, setTotalSteps] = useState(0);
  const [totalDistance, setTotalDistance] = useState("");
  const [totalCalories, setTotalCalories] = useState("");
  const [totalDuration, setTotalDuration] = useState("");
  const [strength, setStrength] = useState([]);
  const [graphType, setGraphType] = useState({
    data: [],
    labels: [],
  });
  const [selectedDataType, setSelectedDataType] = useState("steps");
  const [dateType, setDateType] = useState("week");
  let myId = window.localStorage.getItem("id");
  const [trainersList, setTrainersList] = useState([]);
  const [isTrainer, setIsTrainer] = useState(false);
  const [showEditBioForm, setShowEditBioForm] = useState(false);
  const [isEidtBio, setIsEditBio] = useState(false);
  const [isEditAbout, setIsEditAbout] = useState(false);
  const [about, setAbout] = useState("");
  // React.useEffect(() => {
  //   setHistory(window.history);
  // }, []);

  const setMonth = () => {
    setStartDate(monthstartDate);
    setDateType("month");
  };
  const setWeek = () => {
    setStartDate(weekStartDate);
    setDateType("week");
  };

  //function to chnage graph type
  const extractData = (dataType) => {
    // Ensure graphData is available before mapping over it
    const existingDates = graphValues?.map(
      (activity) => new Date(activity.activity_date)
    );
    const generateDateRange = (startDate, endDate) => {
      const dateRange = [];
      let currentDate = new Date(startDate);

      while (currentDate <= endDate) {
        dateRange.push(new Date(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
      }
      return dateRange;
    };

    // Find the minimum and maximum dates in the existing list
    const minDate = new Date(startDate);
    const maxDate = new Date(enddDatee);

    // Generate a range of dates between the minimum and maximum dates
    const allDatesInRange = generateDateRange(minDate, maxDate);

    // Filter out existing dates from the generated date range
    const missingDates = allDatesInRange.filter(
      (date) => !existingDates.find((existingDate) => +existingDate === +date)
    );

    // Create empty objects for the missing dates and add them to the original list
    missingDates.forEach((date) => {
      const dateString = date.toISOString().split("T")[0];
      graphValues.push({
        id: null,
        user_id: null,
        platform: "apple",
        activity_id: `missing_${dateString}_apple_92`,
        activity_name: "",
        device_name: "",
        activity_type: "Distance",
        duration: "0",
        distance: "0.00",
        calories: "0",
        steps: "0",
        activity_date: dateString,
        platform_user_id: "apple_92",
        created_at: null,
        user: {
          id: null,
          name: "",
          image: "",
        },
      });
    });

    // Sort the list by the activity_date
    graphValues.sort(
      (a, b) => new Date(a.activity_date) - new Date(b.activity_date)
    );
    const extractedData = graphValues?.map((activity) => activity[dataType]);

    const labels = graphValues?.map((activity) => activity.activity_date);

    setGraphType({ data: extractedData, labels });
    // setSelectedDataType(dataType);
  };

  // api call to get user body chages Trainers List
  const fetchBodyChangesTrainers = async () => {
    setIsLoading(true);
    try {
      const result = await Services.getBodyChangesTrainers(userId);
      if (result.status === 200) {
        setTrainersList(result?.data?.data?.list);
        result?.data?.data?.list.map((data) => {
          if (data.trainer_id == (myId ? myId : 0)) setIsTrainer(true);
        });
      }
    } catch (error) {
      console.error(
        "An error occurred while fetching the User Body Changes Trainers List",
        error
      );
      toast.error(
        "An error occurred while fetching the User Body Changes Trainers List",
        {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        }
      );
      return;
    }
    setIsLoading(false);
  };

  //api call for user profile data
  const editProfile = async (
    dob,
    weight,
    weight_unit,
    height,
    height_unit,
    interests,
    activities,
    about
  ) => {
    setIsLoading(true);
    try {
      const result = await Services.editProfile(
        userId,
        userObject?.name,
        dob,
        weight,
        weight_unit,
        height,
        height_unit,
        interests,
        activities,
        about
      );

      if (result.status === 200) {
        userProfile(userId);
        toast.success("Profile Updated Successfully", {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("An Error Occured While Updating Profile", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    }
    setIsLoading(false);
  };
  //api call for user profile data
  const userProfile = async (id) => {
    setIsLoading(true);
    const prams = `user_id=${id}`;
    try {
      const result = await Services.getUserProfile(prams);

      if (result) {
        setUserObject(result?.data?.data);
        setAbout(result?.data?.data?.about);
      } else {
        toast.error(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    userProfile(userId);
  }, [userId]);
  /// APi call to get user strenght exercises

  const userStrength = async (id) => {
    setIsLoading(true);
    try {
      const result = await Services.getStrenghtExercises(id);

      if (result) {
        setStrength(result?.data?.data?.strength);
      } else {
        toast.error(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    userStrength(userId);
  }, [userId]);

  //api call for user stats
  const userStats = async (platform, start_date, end_date, user_id) => {
    setIsLoading(true);
    try {
      const result = await Services.getUserStats(
        platform,
        start_date,
        end_date,
        user_id
      );

      if (result) {
        setGraphValues(result?.data?.data?.listing);
        const steps = result?.data?.data?.listing?.reduce((total, value) => {
          const stepsValue = parseInt(value.steps, 10);
          return Number.isNaN(stepsValue) ? total : total + stepsValue;
        }, 0);
        setTotalSteps(steps);
        const distance = result?.data?.data?.listing?.reduce((total, value) => {
          const distanceValue = parseInt(value.distance, 10);
          return Number.isNaN(distanceValue) ? total : total + distanceValue;
        }, 0);
        setTotalDistance(distance);
        const duration = result?.data?.data?.listing?.reduce((total, value) => {
          const durationValue = parseInt(value.duration, 10);
          return Number.isNaN(durationValue) ? total : total + durationValue;
        }, 0);
        setTotalDuration(duration);
        const calories = result?.data?.data?.listing?.reduce((total, value) => {
          const caloriesValue = parseInt(value.calories, 10);
          return Number.isNaN(caloriesValue) ? total : total + caloriesValue;
        }, 0);
        setTotalCalories(calories);
      } else {
        toast.error(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchBodyChangesTrainers();
    userStats(platform, startDate, endDate, userId);
  }, [
    platform,
    startDate,
    endDate,
    userId,
    setStartDate,
    setDateType,
    dateType,
  ]);

  //api call for user app types
  const appTypesFunction = async (user_id) => {
    setIsLoading(true);
    try {
      const result = await Services.getAppTypes(user_id);

      if (result) {
        setGraphData(result?.data?.data?.listing);
      } else {
        toast.error(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    appTypesFunction(userId);
  }, [userId]);

  const data = {
    labels: graphType?.labels,
    datasets: [
      {
        label:
          selectedDataType.charAt(0).toUpperCase() + selectedDataType.slice(1),
        backgroundColor: "#4E10FF",
        borderColor: "#4E10FF",
        borderWidth: 0,
        hoverBackgroundColor: "#4E10FF",
        hoverBorderColor: "#4E10FF",
        data: graphType?.data, // Handle NaN values
      },
    ],
  };

  useEffect(() => {
    const chartInstances = Chart.instances;

    return () => {
      if (chartInstances && chartInstances.length) {
        chartInstances.forEach((instance) => {
          if (instance.chart.canvas.id !== "my-chart-id") {
            instance.destroy();
          }
        });
      }
    };
  }, []);
  useEffect(() => {
    extractData(selectedDataType);
  }, [selectedDataType, setSelectedDataType, graphValues, setGraphValues]);

  const editBio = () => {
    return (
      <EditBio
        handleCloseEditBIo={handleCloseEditBIo}
        isEidtBio={isEidtBio}
        userObject={userObject}
        setUserObject={setUserObject}
        editProfile={editProfile}
      />
    );
  };

  const handleEditBio = (type) => {
    type === 1 ? setIsEditBio(true) : setIsEditBio(false);
    setShowEditBioForm(true);
  };

  const handleCloseEditBIo = () => {
    setShowEditBioForm(false);
    setIsEditBio(false);
  };
  return (
    <div className="wrapper-dashboard">
      {isLoading && (
        <div className="loaderparent">
          <div className="loader"></div>
        </div>
      )}

      <div className="right-small">
        <div className="container user-container">
          <div className="user-profile-wrapper">
            {userObject?.image && (
              <div className="profile">
                <img
                  src={`${BASE_URL_MEDIA}/storage/assets/uploads/${userObject?.image}`}
                  alt=""
                />
              </div>
            )}
            <span className="name">{userObject?.name}</span>
          </div>
          <ul className="user-tabs mb-3">
            <li
              className={`${activeTab == "stats" ? "tab active" : "tab"} `}
              onClick={() => setActiveTab("stats")}
            >
              Stats
            </li>
            <li
              className={`${activeTab == "bio" ? "tab active" : "tab"} `}
              onClick={() => setActiveTab("bio")}
            >
              Bio
            </li>
            <li
              className={`${activeTab == "about" ? "tab active" : "tab"} `}
              onClick={() => setActiveTab("about")}
            >
              About me
            </li>
            <li
              className={`process-progress-tab${
                activeTab == "progress" ? ` tab active` : " tab"
              } `}
              onClick={() => {
                (isTrainer || userId == myId) && setActiveTab("progress");
              }}
            >
              Progress
              {!isTrainer && userId != myId && (
                <i className="fa fa-lock progress-lock-icon"></i>
              )}
            </li>
          </ul>

          <div className="user-main-wrapper">
            {activeTab == "stats" && (
              <div className="stats_container">
                <div className="graph-buttons">
                  <button
                    className={`${selectedDataType == "steps" ? "active" : ""}`}
                    onClick={() => setSelectedDataType("steps")}
                  >
                    Steps
                  </button>
                  <button
                    className={`${
                      selectedDataType == "calories" ? "active" : ""
                    }`}
                    onClick={() => setSelectedDataType("calories")}
                  >
                    Calories
                  </button>
                  <button
                    className={`${
                      selectedDataType == "distance" ? "active" : ""
                    }`}
                    onClick={() => setSelectedDataType("distance")}
                  >
                    Distance
                  </button>

                  <button
                    className={`${
                      selectedDataType == "duration" ? "active" : ""
                    }`}
                    onClick={() => setSelectedDataType("duration")}
                  >
                    Duration
                  </button>
                </div>

                <div className="bar_wrapper">
                  <Bar data={data} />
                </div>

                <div className="month-week my-3">
                  <button
                    onClick={() => setWeek()}
                    className={`${dateType == "week" ? "active" : ""}`}
                  >
                    Week
                  </button>
                  <button
                    onClick={() => setMonth()}
                    className={`${dateType == "month" ? "active" : ""}`}
                  >
                    Month
                  </button>
                </div>
                <div className="app-type">
                  <span className="name">
                    {dateType == "week" ? "Week" : "Month"}
                  </span>
                  <div className="apps">
                    {graphData?.map((app) => (
                      <div className="app-icon">
                        {app?.platform === "apple" ? (
                          <img
                            title="Apple"
                            src={appleimg}
                            className={`${platform == "apple" ? "active" : ""}`}
                            onClick={() => setPlatform("apple")}
                          />
                        ) : app?.platform === "google_fit" ? (
                          <img
                            title="Google fit"
                            src={google_fit}
                            className={`${
                              platform == "google_fit" ? "active" : ""
                            }`}
                            onClick={() => setPlatform("google_fit")}
                          />
                        ) : app?.platform === "colmi" ? (
                          <img
                            title="Colmi"
                            src={watchimg}
                            className={`${platform == "colmi" ? "active" : ""}`}
                            onClick={() => setPlatform("colmi")}
                          />
                        ) : app?.platform === "fitbit" ? (
                          <img
                            title="Fitbit"
                            src={fitbitimg}
                            className={`${
                              platform == "fitbit" ? "active" : ""
                            }`}
                            onClick={() => setPlatform("fitbit")}
                          />
                        ) : app?.platform === "garmin" ? (
                          <img
                            title="Garmin"
                            src={garminimg}
                            className={`${
                              platform == "garmin" ? "active" : ""
                            }`}
                            onClick={() => setPlatform("garmin")}
                          />
                        ) : app?.platform === "samsung" ? (
                          <img
                            title="Samsung"
                            src={samsungimg}
                            className={`${
                              platform == "samsung" ? "active" : ""
                            }`}
                            onClick={() => setPlatform("samsung")}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="info">
                  <span>Steps</span>
                  {totalSteps > 0 ? <span>{totalSteps}</span> : <span>0</span>}
                </div>
                <div className="info">
                  <span>Distance</span>
                  {totalDistance > 0 ? (
                    <span>{totalDistance} km</span>
                  ) : (
                    <span>0 km</span>
                  )}
                </div>
                <div className="info">
                  <span>Calories</span>
                  {totalCalories > 0 ? (
                    <span>{totalCalories} </span>
                  ) : (
                    <span>0</span>
                  )}
                </div>
                <div className="info">
                  <span>Duration</span>
                  {totalDuration > 0 ? (
                    <span>{totalDuration} </span>
                  ) : (
                    <span>0</span>
                  )}
                </div>
              </div>
            )}
            {showEditBioForm && editBio()}
            {activeTab == "bio" && (
              <div className="bio_container">
                <p className="title">Bio</p>
                {(isTrainer || userId == myId) && (
                  <div className="d-flex justify-content-end">
                    <i
                      className="fa fa-pencil edit-bio-icon"
                      onClick={() => handleEditBio(1)}
                    />
                  </div>
                )}
                <div className="info">
                  <span>Date of birth</span>
                  <span>{userObject?.dob}</span>
                </div>
                <div className="info">
                  <span>Gender</span>
                  <span>{userObject?.gender}</span>
                </div>
                <div className="info">
                  <span>Height</span>
                  <span>
                    {userObject?.height} {userObject?.height_unit}
                  </span>
                </div>
                <div className="info">
                  <span>Weight</span>
                  <span>
                    {userObject?.weight} {userObject?.weight_unit}
                  </span>
                </div>
                <p className="title mb-3">Strength Exercises</p>

                <div className="table-respoinsive strength-table">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Exercise</th>
                        <th>Max Weight</th>
                        <th>Rep</th>
                      </tr>
                    </thead>
                    <tbody>
                      {strength?.map((strn) => (
                        <tr>
                          {strn?.weight > 0 && <td>{strn?.name}</td>}
                          {strn?.weight > 0 && <td>{strn?.weight} kg</td>}
                          {strn?.weight > 0 && <td>{strn?.rep}</td>}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <p className="title mb-3">Intrest and Activities</p>
                {(isTrainer || userId == myId) && (
                  <div className="d-flex justify-content-end">
                    <i
                      className="fa fa-pencil edit-bio-icon"
                      onClick={() => handleEditBio(0)}
                    />
                  </div>
                )}

                <ul className="activities mb-2">
                  {userObject?.activities &&
                    JSON.parse(userObject?.activities)?.map((intr) => (
                      <li>{intr}</li>
                    ))}
                </ul>
                <ul className="activities">
                  {userObject?.interests &&
                    JSON.parse(userObject?.interests)?.map((intr) => (
                      <li>{intr}</li>
                    ))}
                </ul>
              </div>
            )}
            {activeTab == "about" && (
              <div className="about_container bio_container">
                <p className="title">About me</p>

                {(isTrainer || userId == myId) && (
                  <div className="d-flex justify-content-end">
                    <i
                      className={`edit-bio-icon fa ${
                        !isEditAbout ? "fa-pencil" : "fa-save"
                      }`}
                      onClick={() => {
                        !isEditAbout
                          ? setIsEditAbout(true)
                          : setIsEditAbout(false);
                        isEditAbout &&
                          editProfile(
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            about
                          );
                      }}
                    />
                  </div>
                )}
                {!isEditAbout ? (
                  <p className="about-me">{about}</p>
                ) : (
                  <textarea
                    disabled={!isEditAbout}
                    id="id167"
                    className="about-me"
                    value={about}
                    style={{
                      border: "none",
                      height: "220px",
                      overflow: "hidden",
                      textAlign: "left",
                    }}
                    onChange={(e) => setAbout(e.target.value)}
                  />
                )}
              </div>
            )}

            {activeTab == "progress" && (
              <ProgressModel
                userId={userId}
                myId={myId}
                trainersList={trainersList}
                setTrainersList={setTrainersList}
                fetchBodyChangesTrainers={fetchBodyChangesTrainers}
                loadingTrainers={isLoading}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserStats;
